var _defs, _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgExportJiraIcon = function SvgExportJiraIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "441.462 237 25.381 26"
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "export-jira-icon_svg__a",
    x1: 10.806,
    x2: 6.405,
    y1: 6.21,
    y2: 10.402,
    gradientTransform: "translate(441.463 237)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0052CC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2684FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "export-jira-icon_svg__b",
    x1: 14.128,
    x2: 18.515,
    y1: 19.728,
    y2: 15.215,
    gradientTransform: "translate(441.463 237)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0052CC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2684FF"
  })))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#2684FF",
    d: "m466.54 249.272-11.293-11.188-1.094-1.084-12.387 12.272a1.023 1.023 0 0 0 0 1.455l7.767 7.695 4.62 4.578 12.387-12.273a1.023 1.023 0 0 0 0-1.455m-12.387 4.571L450.274 250l3.879-3.844 3.879 3.844z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#export-jira-icon_svg__a)",
    d: "M453.844 246.135c-2.4-2.52-2.412-6.601-.026-9.135l-8.022 8.417 4.366 4.583z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#export-jira-icon_svg__b)",
    d: "m457.806 250-3.962 3.851a6.38 6.38 0 0 1 1.95 4.574 6.38 6.38 0 0 1-1.95 4.575l8.666-8.425z"
  })));
};
export default SvgExportJiraIcon;